import * as Icons from "@nova/component-icons"
import {
    MissionGroupIcon as TMissionGroupIcon,
    MissionGroupColor,
    missionGroupColors,
    missionGroupIcons,
} from "@nova/schemas"
import classNames from "classnames"
import { useAppSelector } from "integrations/redux/hooks"
import { selectContactListById } from "./slice"

const missionGroupIconsMap = {
    contactEmergency: Icons.ContactEmergency,
    directionsRun: Icons.DirectionsRun,
    e911Emergency: Icons.E911Emergency,
    localFireDepartment: Icons.LocalFireDepartment,
    fireTruck: Icons.FireTruck,
    domain: Icons.Domain,
    adminPanelSettings: Icons.AdminPanelSettings,
    localPolice: Icons.LocalPolice,
    emergency: Icons.Emergency,
    healthCross: Icons.HealthCross,
} satisfies Record<TMissionGroupIcon, Icons.IconComponent>

type ManualProps = {
    icon: TMissionGroupIcon
    color: MissionGroupColor
    groupId?: never
}
type AutoProps = {
    icon?: never
    color?: never
    groupId: string
}

export const MissionGroupIcon = ({
    icon: iconProp,
    color: colorProp,
    groupId,
    size = "40",
    transition = false,
}: (ManualProps | AutoProps) & { size?: "40" | "32" | "24" | "20"; transition?: boolean }) => {
    const group = useAppSelector(selectContactListById(groupId ?? ""))
    const icon = groupId ? (group?.icon ?? missionGroupIcons[0]) : iconProp!
    const color = groupId ? (group?.color ?? missionGroupColors[0]) : colorProp!
    const IconComponent =
        size === "20" ? Icons.ExtraSmallIcon : size === "24" ? Icons.SmallIcon : Icons.Icon
    return (
        <div
            className={classNames("relative flex justify-center items-center overflow-hidden", {
                "w-10 h-10 rounded-lg": size === "40",
                "w-8 h-8 rounded-md": size === "32",
                "w-6 h-6 rounded-[4.5px]": size === "24",
                "w-5 h-5 rounded-md": size === "20",
                "transition-colors": transition,
            })}
            style={{
                backgroundColor: color,
            }}
        >
            <IconComponent Icon={missionGroupIconsMap[icon]} className="text-white" />
        </div>
    )
}
